import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import { DASHBOARD_ROUTES } from "../dashboardRoutes";
import { AUTH_ROUTES } from "../../components/authRoutes";
import HeaderProfileSection from "../HeaderProfileSection";
import MyWalletSidebar from "../MyWalletSidebar";
import { useReferralHistory, useReferralLeaderboard, useReferralSummary } from "../../hooks/useReferralData";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import MyRewardTab from "./MyRewardTab";
import HistoryTab from "./HistoryTab";
import HowitWorksTab from "./HowitWorksTab";
import { showManualCopyAlert, showReferralAlert } from "./referralAlerts";
import "../DashboardFavoriteExam.css";
import "./Referralearn.css";
import "./ReferralPreviewLayout.css";

export default function Referralearn() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("rewards");
  const summaryQuery = useReferralSummary();
  const leaderboardQuery = useReferralLeaderboard();
  const historyQuery = useReferralHistory(activeTab === "history");
  const summary = summaryQuery.data;
  const title = summary?.category_name || "Referral & Earn";
  const titleBreak = title.lastIndexOf(" ");
  const referralCode = summary?.referral_code || "";
  const invitationLink = referralCode ? `${window.location.origin}${AUTH_ROUTES.signUp}?referral_code=${encodeURIComponent(referralCode)}` : "";

  const shareInvitation = async () => {
    if (!referralCode) return;
    const text = [summary?.referral_message, invitationLink].filter(Boolean).join("\n");
    if (navigator.share) {
      try {
        await navigator.share({ title: "Refer & Earn Invitation", text });
      } catch (error) {
        if (error?.name === "AbortError") return;
        // Fall back to copying when native sharing is unavailable.
        return copyInvitation(text);
      }
      await showReferralAlert({ icon: "success", title: "Invitation shared", text: "Your referral invitation is ready for your friend." });
      return;
    }
    await copyInvitation(text);
  };

  const copyInvitation = async (text) => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard unavailable");
      await navigator.clipboard.writeText(text);
    } catch {
      await showManualCopyAlert("Copy your invitation", text);
      return;
    }
    await showReferralAlert({ icon: "success", title: "Invitation copied", text: "Share it with your friends to invite them." });
  };

  return <HomeDashboardLayout showHeader={false} variant="referral-preview">
    <div className="qbl-page qbankList-page page-padding">
      <div className="start-quiz qbl-main instruction-main">
        <div className="hideProfile-page"><div className="categories-page-header mb-0">
          <div><button type="button" className="categories-back-button" onClick={() => navigate(DASHBOARD_ROUTES.home)} aria-label="Back to dashboard"><i className="bi bi-chevron-left" /></button></div>
          <div><h4 className="d-flex d-sm-none categories-page-title"><span className="visually-hidden">Refer and Earn</span></h4></div>
          <div><HeaderProfileSection /></div>
        </div></div>
        <div className="rapid-fire-header ex-header"><h1 className="qb-title">{titleBreak > 0 ? <>{title.slice(0, titleBreak)} <span>{title.slice(titleBreak + 1)}</span></> : title}</h1></div>
        <p className="game-description">Invite friends, track referrals, and earn rewards.</p>
        <div className="rewards-page"><div className="rewards-container">
          <div className="reward-tabs" role="tablist" aria-label="Referral sections">
            {[{ key: "rewards", label: "My Rewards" }, { key: "history", label: "History" }, { key: "how", label: "How does it work?" }].map((tab) => <button key={tab.key} type="button" role="tab" aria-selected={activeTab === tab.key} className={activeTab === tab.key ? "active" : ""} onClick={() => { if (tab.key === "history" && activeTab === "history") historyQuery.refetch(); setActiveTab(tab.key); }}>{tab.label}</button>)}
          </div>
          <div className="reward-tab-content" role="tabpanel">
            {activeTab === "rewards" && <MyRewardTab summaryQuery={summaryQuery} leaderboardQuery={leaderboardQuery} />}
            {activeTab === "history" && <HistoryTab query={historyQuery} />}
            {activeTab === "how" && <HowitWorksTab summaryQuery={summaryQuery} />}
          </div>
          <div className="refer-now-footer">
            <div className="refer-now-footer__text">
              <strong>Invite friends. Earn together.</strong>
              <span>Share your referral link in one tap.</span>
            </div>
            <button type="button" className="refer-now-btn" onClick={shareInvitation} disabled={!referralCode}>
              <i className="bi bi-send-fill" aria-hidden="true" /> Refer now
            </button>
          </div>
        </div></div>
      </div>
    </div>
    <MyWalletSidebar withTopOffset={false} />
  </HomeDashboardLayout>;
}
